import { render, staticRenderFns } from "./msgrsHist.vue?vue&type=template&id=6ea6eda4&"
import script from "./msgrsHist.vue?vue&type=script&lang=ts&"
export * from "./msgrsHist.vue?vue&type=script&lang=ts&"
import style0 from "./msgrsHist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports